import React, {Component} from 'react';
import './Form.css';
import FormErrorMessages from './FormErrorMessages';
import LoadingScreen from './LoadingScreen';
import AutoCompleteCityField from './AutoCompleteCityField';
import AutoCompleteAddressField from './AutoCompleteAddressField';
import AutoCompleteRegionField from './AutoCompleteRegionField';
import { getAutoCompleteState, getAutoCompleteZipCode, getAutoCompleteCity, getAutoCompleteStreetNumber, getAutoCompleteStreetName } from '../utils/places';

// import Script from 'react-load-script';

class Form extends Component {

  constructor(props) {
    super(props);

    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleFieldChange = this.handleFieldChange.bind(this);
    this.autocomplete = null;
    this.addressRef = React.createRef();
    this.cityRef = React.createRef();
    this.zipCodeRef = React.createRef();
    
    this.state = {
      fields: {
        firstName: '',
        lastName: '',
        email: '',
        phoneNumber: '',
        address1: '',
        address2: '',
        city:'',
        state: '',
        zipCode: '',
        tvProvider: '',
        agreeEmail: false, 
        agreeText: false,
        panelHeight: 0,
        validatedAddress: ''
      },
      isLoading: false,
      errors: {},
      requiredFields: {
        'firstName':'First Name Required', 
        'lastName':'Last Name Required', 
        'email':'Email Required'
      },
      userInitSubmit: false,
      submitForm: false
    }

    this.formPanel = React.createRef();
  }

  handleAddressSelect = (address) => {

    const fields = Object.assign({}, this.state.fields);

    // Check if address is valid
    if (address) {
      // Set State
      fields.address1 = getAutoCompleteStreetNumber(address) + ' ' + getAutoCompleteStreetName(address);
      fields.city = getAutoCompleteCity(address);
      fields.state = getAutoCompleteState(address);
      fields.zipCode = getAutoCompleteZipCode(address);
      this.setState({fields});
    }
  }

  handleCitySelect = (address) => {

    const fields = Object.assign({}, this.state.fields);

    // Check if address is valid
    if (address) {
      // Set State

      fields.city = getAutoCompleteCity(address);
      fields.state = getAutoCompleteState(address);
      this.setState({fields});
    }
  }

  handleZipCodeSelect = (address) => {

    const fields = Object.assign({}, this.state.fields);

    // Check if address is valid
    if (address) {
      // Set State
      fields.zipCode = getAutoCompleteZipCode(address);
      fields.state = getAutoCompleteState(address);
      this.setState({fields});
    }
  }

  handleSubmit(evt) {
    evt.preventDefault();
    evt.stopPropagation();

    const errors = this.formValidation();

    // this.props.handleSubmit(this.state);
    this.setState({
      userInitSubmit: true,
      isLoading: true,
      errors
    });

  }

  handleFieldChange(evt) {
    const {name, type, value} = evt.target;
    let fieldVal = value;
    
    // console.log('handleFieldChange', (type==='tel' && !!!this.handlePhoneFieldChange(evt) && value), (type!=='checkbox' && value), !this.state.fields[name])
    if (type==='tel') {
      fieldVal = this.handlePhoneFieldChange(value, evt);
    }
    
    if (type==='checkbox') {
      fieldVal = !this.state.fields[name];
    }

    const fields = Object.assign(this.state.fields, {[name]:fieldVal});
    this.setState({fields});
  }
  
  handlePhoneFieldChange(str, evt) {
		//ignore backspace and delete keys
		if (evt.keyCode !== 8 && evt.keyCode !== 46) {
			const val = str.replace(/\D/g,'');
			
      return val.substring(0,3) + '-' + val.substring(3,6) + '-' + val.substring(6,10);
		}
	}

  hasErrors() {
    return Object.keys(this.state.errors).length !== 0;
  }

  setRequiredFieldsError() {
    const {requiredFields, fields} = this.state,
      errors = {},
      fieldsWithErrors = Object.keys(requiredFields).filter(name=>fields[name]==='');

    fieldsWithErrors.forEach(name=>errors[name]=requiredFields[name])

    return errors;
  }

  formValidation(errors) {
    const { fields } = this.state,
      validationErrors = {},
      requiredFieldsErrors = this.setRequiredFieldsError();

    const emptyPhoneField = !fields.phoneNumber || fields.phoneNumber === '--';

    if (!emptyPhoneField && !(/\d{3}-\d{3}-\d{4}/.test(fields.phoneNumber))) {
      validationErrors['phoneNumber'] = 'Incorrect Phone Number format ex. XXX-XXX-XXX';
    }
    
    if (fields.agreeText && emptyPhoneField) {
      validationErrors['phoneNumber'] = 'Phone Number Format Error ex. XXX-XXX-XXX.';
    }
// console.log('formValidation', Object.assign(errors, validationErrors));
    return Object.assign(requiredFieldsErrors, validationErrors);
  }

  backendValidationErrors() {
    const submitError = (this.props.submitError && this.props.submitError.field) || this.state.errors;
    this.setState({errors: submitError});
  }

  // Passed to result panel to set height of result panel
  setFormPanelHeight() {
    const panelHeight = this.formPanel.current.clientHeight,
      fields = Object.assign(this.state.fields, {panelHeight});

    this.setState({fields});
  }

  // populate with local storage data or data returned after backend validation error
  populateWithData() {
    const { data } = this.props;
    const fields = Object.assign({}, data);

    console.log('populateWithData', data, Object.keys(data).length);
    Object.keys(data).length > 0 && this.setState({fields});
  }

  componentDidMount() {
    this.setFormPanelHeight();
    this.populateWithData();
  }

  render() {

    const classNames = {
      firstName: 'first-name',
      lastName: 'last-name',
      email: 'email',
      phoneNumber: 'phone-number'
    }

    const {
      errors,
      fields
    } = this.state;

    if (errors) {
      Object.keys(errors).forEach((key)=>{
        classNames[key] += ' error';
      });
    }

    return (
      <div className="submission-form">
        <form action="" method="post" onSubmit={this.handleSubmit}>
          <div className="form-fields" ref={this.formPanel}>
            <h3>Complete the Form</h3>
            <FormErrorMessages
              errors={errors}
              />
            <fieldset>
              <input className={classNames['firstName']} name="firstName" placeholder="First Name*" onChange={this.handleFieldChange} required value={fields.firstName} />
              <input className={classNames['lastName']} name="lastName" placeholder="Last Name*" onChange={this.handleFieldChange} required value={fields.lastName} />
            </fieldset>
            <fieldset>
              <input type="email" className={classNames['email']} name="email" placeholder="Email*" onChange={this.handleFieldChange} required value={fields.email} />
              <input type="tel" className={classNames['phoneNumber']} name="phoneNumber" placeholder="Phone Number" onChange={this.handleFieldChange} value={fields.phoneNumber} />
            </fieldset>
            <fieldset>
              <AutoCompleteAddressField 
                className="address1" 
                name="address1" 
                placeholder="Street Address*" 
                onChange={this.handleFieldChange} 
                required="true" 
                value={fields.address1} 
                ref={this.addressRef} 
                handlePlaceSelect={this.handleAddressSelect} 
                />
              <input className="address2" name="address2" placeholder="Unit" onChange={this.handleFieldChange} value={fields.address2} />
            </fieldset>
            <fieldset>
              <AutoCompleteCityField 
                className="city" 
                name="city" 
                placeholder="City*" 
                onChange={this.handleFieldChange} 
                required="true" value={fields.city} 
                ref={this.cityRef} 
                handlePlaceSelect={this.handleCitySelect} 
                />
              <select className="state" name="state" onChange={this.handleFieldChange} required value={fields.state} >
                <option value="">State*</option>
                <option value="AL">AL</option>
                <option value="AK">AK</option>
                <option value="AZ">AZ</option>
                <option value="AR">AR</option>
                <option value="CA">CA</option>
                <option value="CO">CO</option>
                <option value="CT">CT</option>
                <option value="DE">DE</option>
                <option value="DC">DC</option>
                <option value="FL">FL</option>
                <option value="GA">GA</option>
                <option value="HI">HI</option>
                <option value="ID">ID</option>
                <option value="IL">IL</option>
                <option value="IN">IN</option>
                <option value="IA">IA</option>
                <option value="KS">KS</option>
                <option value="KY">KY</option>
                <option value="LA">LA</option>
                <option value="ME">ME</option>
                <option value="MD">MD</option>
                <option value="MA">MA</option>
                <option value="MI">MI</option>
                <option value="MN">MN</option>
                <option value="MS">MS</option>
                <option value="MO">MO</option>
                <option value="MT">MT</option>
                <option value="NE">NE</option>
                <option value="NV">NV</option>
                <option value="NH">NH</option>
                <option value="NJ">NJ</option>
                <option value="NM">NM</option>
                <option value="NY">NY</option>
                <option value="NC">NC</option>
                <option value="ND">ND</option>
                <option value="OH">OH</option>
                <option value="OK">OK</option>
                <option value="OR">OR</option>
                <option value="PA">PA</option>
                <option value="RI">RI</option>
                <option value="SC">SC</option>
                <option value="SD">SD</option>
                <option value="TN">TN</option>
                <option value="TX">TX</option>
                <option value="UT">UT</option>
                <option value="VT">VT</option>
                <option value="VA">VA</option>
                <option value="WA">WA</option>
                <option value="WV">WV</option>
                <option value="WI">WI</option>
                <option value="WY">WY</option>
              </select>
              {/* <input type="number" className="zip-code" name="zipCode" placeholder="Zip Code" onChange={this.handleFieldChange} maxLength="5" value={fields.zipCode} /> */}
              <AutoCompleteRegionField 
                type="number" 
                className="zip-code" 
                name="zipCode" 
                placeholder="Zip Code*" 
                onChange={this.handleFieldChange} 
                maxLength="5" 
                required="true" 
                value={fields.zipCode} 
                ref={this.zipCodeRef} 
                handlePlaceSelect={this.handleZipCodeSelect}
                />
            </fieldset>
            <fieldset>
              <select className="tv-provider" name="tvProvider" onChange={this.handleFieldChange} required value={fields.tvProvider} >
                <option value="">Select A Provider *</option>
                <option>AT&amp;T U-verse</option>
                <option>Xfinity/Comcast</option>
                <option>Cox Communications</option>
                <option>DirecTV</option>
                <option>DISH Network</option>
                <option>Spectrum</option>
                <option>Optimum</option>
                <option>Suddenlink</option>
                <option>Verizon FiOS</option>
                <option>Frontier Communications</option>
                <option>Rogers</option>
                <option>Shaw</option>
                <option>Other</option>
              </select>
            </fieldset>
            <fieldset>
              <button className="submit gotham-ultra">Spin</button>
            </fieldset>
            <fieldset>
              <label>
                <input className="agree-email" type="checkbox" name="agreeEmail" checked={this.state.fields.agreeEmail} onChange={this.handleFieldChange} />
                I would like to receive Game Show Network emails
              </label>
            </fieldset>
            <fieldset>
              <label>
              <input className="agree-text" type="checkbox" name="agreeText" checked={this.state.fields.agreeText} onChange={this.handleFieldChange} />
                You consent and agree to that type of contact and more generally to our online <a href="https://www.gsntv.com/legal/privacy-policy" target="_top">Privacy Policy</a> when you submit your registration. Standard text message and data rates may apply. Text HELP to 31996 for help. Text STOP to 	31996 to cancel. If you sign up for text messages online or through a mobile app, you may be asked by text message to confirm your decision. This double opt-in is designed to ensure that the person who entered the mobile number in the app or on the website is the person who is actually in possession of the phone that corresponds to that number. You can opt out at any time. You are not required agree to this as a condition of purchasing any property, goods, or services. Submitting your phone number constitutes your electronic signature and agreement to the foregoing.
              </label>
            </fieldset>
            {this.state.isLoading &&
              <LoadingScreen />
            }
          </div>
          <div className="legal">
            <p>
              By clicking Spin I acknowledge I am 18 years old or older and that I understand and agree to the <a href="https://www.gameshownetwork.com/25daysofchristmas/rules" target="_top">Official Rules</a> and <a href="https://www.gsntv.com/legal/terms" target="_top">Terms of Service</a>.
            </p>
          </div>
        </form>
        {/* <Script 
          url="https://maps.googleapis.com/maps/api/js?key=AIzaSyBYxzlRTHuRxuOLvDShKLQ16rsabTEmcdE&libraries=places"          
          onLoad={this.handlePlacesScriptLoad}        
        />  */}
      </div>
    )
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevProps.data !== this.props.data) {
      this.populateWithData();
    }

    if (prevProps.submitError!==this.props.submitError) {
      this.setState({isLoading:false});
      this.backendValidationErrors();
    }

    //submitting data to backend
    if (this.state.submitForm === true && prevState.submitForm !== this.state.submitForm) {
      this.props.handleSubmit(this.state.fields);
      this.setState({submitForm: false});
    }

    //check errors before submitting
    if (this.state.userInitSubmit === true && prevState.userInitSubmit !== this.state.userInitSubmit) {
      if (!this.hasErrors()){
        this.setState({submitForm: true});
      } else {
        this.setState({isLoading: false});
      }
      this.setState({userInitSubmit: false});
    } 
  }
}

export default Form;